export default {
  'Afghan': 'Afghanistan',
  'Argentine Argentinian': 'Argentina',
  'Australian': 'Australia',
  'Belgian': 'Belgium',
  'Bolivian': 'Bolivia',
  'Brazilian': 'Brazil',
  'Cambodian': 'Cambodia',
  'Cameroonian': 'Cameroon',
  'Canadian': 'Canada',
  'Chilean': 'Chile',
  'Chinese': 'China',
  'Colombian': 'Colombia *',
  'Costa Rican': 'Costa Rica',
  'Cuban': 'Cuba',
  'Danish (Dane)': 'Denmark',
  'Dominican': 'Dominican Republic',
  'Ecuadorian': 'Ecuador',
  'Egyptian': 'Egypt',
  'Salvadorian': 'El Salvador',
  'English': 'England',
  'Estonian': 'Estonia',
  'Ethiopian': 'Ethiopia',
  'Finnish': 'Finland',
  'French': 'France',
  'German': 'Germany',
  'Ghanaian': 'Ghana',
  'Greek': 'Greece',
  'Guatemalan': 'Guatemala',
  'Haitian': 'Haiti',
  'Honduran': 'Honduras',
  'Indonesian': 'Indonesia',
  'Iranian': 'Iran',
  'Irish': 'Ireland',
  'Israeli': 'Israel',
  'Italian': 'Italy',
  'Japanese': 'Japan',
  'Jordanian': 'Jordan',
  'Kenyan': 'Kenya',
  'Laotian': 'Laos',
  'Latvian': 'Latvia',
  'Lebanese': 'Lebanon',
  'Lithuanian': 'Lithuania',
  'Malaysian': 'Malaysia',
  'Mexican': 'Mexico',
  'Moroccan': 'Morocco',
  'Dutch': 'Netherlands',
  'New Zealander': 'New Zealand',
  'Nicaraguan': 'Nicaragua',
  'Norwegian': 'Norway',
  'Panamanian': 'Panama',
  'Paraguayan': 'Paraguay',
  'Peruvian': 'Peru',
  'Filipino': 'Philippines',
  'Polish': 'Poland',
  'Portuguese': 'Portugal',
  'Puerto Rican': 'Puerto Rico',
  'Romanian': 'Romania',
  'Russian': 'Russia',
  'Saudi': 'Saudi Arabia',
  'Scottish': 'Scotland',
  'Korean': 'South Korea',
  'Spanish': 'Spain',
  'Swedish': 'Sweden',
  'Swiss': 'Switzerland',
  'Taiwanese': 'Taiwan',
  'Tajik': 'Tajikistan',
  'Thai': 'Thailand',
  'Turkish': 'Turkey',
  'Ukrainian': 'Ukraine',
  'British': '(The) United Kingdom',
  'American **': '(The) United States',
  'Uruguayan': 'Uruguay',
  'Venezuelan': 'Venezuela',
  'Vietnamese': 'Vietnam',
  'Welsh': 'Wales'
}



// WEBPACK FOOTER //
// ./src/views/components/nationalityListInit.js